import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { UTILITY_USER_ROLE_ADMIN } from 'common/utility/userRoles';

import branch from 'client/core/branch';
import withScreenId from 'client/helpers/withScreenId';
import withTransitionHook from 'client/helpers/withTransitionHook';
import withScrollToTop from 'client/helpers/withScrollToTop';
import allowedUtilityRoles from 'client/helpers/allowedUtilityRoles';
import { SCREEN_ID_UTILITY_PROFIT_ADMIN_BCC_REMINDERS } from 'client/constants/screenIds';

import UtilityPartnerActions from 'client/actions/UtilityPartner';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import SrUtilityProfitAdminBccReminderForm from 'client/components/SrUtilityProfit/SrUtilityProfitAdminBccReminderForm';
import SrPartnerPageV2 from 'client/components/SrPartnerPageV2/SrPartnerPageV2';

@withTransitionHook
@withScreenId(SCREEN_ID_UTILITY_PROFIT_ADMIN_BCC_REMINDERS)
@withScrollToTop
@allowedUtilityRoles({
  roles: [UTILITY_USER_ROLE_ADMIN],
  addRedirectQueryParam: true,
})
@branch({
  utilityPartnerList: ['utilityPartners', 'list'],
})
class UtilityProfitAdminBccReminderPage extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Register Address | Utility Profit',
  });

  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    utilityPartnerList: PropTypes.array,
  };

  static fetchData(match, inject) {
    return Promise.all([UtilityPartnerActions.getList(inject)]);
  }

  render() {
    const { dispatch, utilityPartnerList } = this.props;

    return (
      <SrPartnerPageV2
        navbarTitle="Utility Profit Admin"
        navbarImage="/images/utility-profit-logo.svg"
        backUrl="/utility-profit/admin"
        redirectToLastLocation={false}
      >
        <SrBox paddingBottom="10px">
          <SrText weight="800" size="28" font="greycliff">
            Send BCC Reminder
          </SrText>
        </SrBox>
        <SrUtilityProfitAdminBccReminderForm
          utilityPartnerList={utilityPartnerList}
          dispatch={dispatch}
        />
      </SrPartnerPageV2>
    );
  }
}

UtilityProfitAdminBccReminderPage.displayName = 'UtilityProfitAdminBccReminderPage';

export default UtilityProfitAdminBccReminderPage;
